import React from "react";

type Option = { label: string; value: string };

export function RadioGroup({
                               name,
                               value,
                               options,
                               onChange,
                               indicatorStyle,
                           }: {
    name: string;
    value: string | number | boolean;
    options: Option[];
    onChange: (v: string) => void;
    indicatorStyle?: React.CSSProperties;
}) {
    return (
        <div className="rg" role="radiogroup" aria-label={name}>
            {options.map((o, i) => {
                const checked = String(value) === o.value;
                return (
                    <label key={i} className={`rg-item ${checked ? "is-checked" : ""}`}>
                        <input
                            type="radio"
                            name={name}
                            value={o.value}
                            checked={checked}
                            onChange={(e) => onChange(e.target.value)}
                            className="rg-input"
                        />
                        <span className="rg-indicator" style={indicatorStyle} aria-hidden="true" />
                        <span className="rg-label">{o.label}</span>
                    </label>
                );
            })}
        </div>
    );
}
